/* testDataSlice.ts */

/* Redux Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Thunks */
import {
  deleteTestData,
  fetchTestData,
  importTestData,
} from "src/redux/thunks/test-data/testDataThunk";

/* Interfaces */
import { TestDataSliceProps } from "src/shared/interfaces/common/Slice";
import { TestDataProps } from "src/shared/interfaces/common/TestData";

const initialState: TestDataSliceProps = {
  data: {},
  importedData: [],
  isLoading: false,
  error: undefined,
  modifiedAt: undefined,
};

export const testDataSlice = createSlice({
  name: "testData",
  initialState: initialState,
  reducers: {
    resetTestData: (state) => {
      return { ...state, importedData: [] };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTestData.pending, (state) => {
      state.isLoading = true;
      state.error = undefined;
    });
    /**
     * Fetch test data.
     */
    builder.addCase(
      fetchTestData.fulfilled,
      (state, action) => {
        const prevData = state.data;
        state.data = action.payload;
        state.isLoading = false;

        if (
          prevData &&
          JSON.stringify(prevData) !==
            JSON.stringify(state.data)
        ) {
          state.modifiedAt = new Date().toISOString();
        }
      }
    );
    /**
     * Import test data.
     */
    builder.addCase(importTestData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      importTestData.fulfilled,
      (state, action: PayloadAction<TestDataProps>) => {
        state.importedData.push(action.payload);
        state.isLoading = false;
        state.modifiedAt = new Date().toISOString();
      }
    );
    /**
     * Delete test data.
     */
    builder.addCase(deleteTestData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      deleteTestData.fulfilled,
      (state, action: PayloadAction<TestDataProps>) => {
        state.isLoading = false;
        state.importedData = state.importedData.filter(
          (item) =>
            !(
              item.foldername ===
                action.payload.foldername &&
              item.name === action.payload.name
            )
        );
        state.modifiedAt = new Date().toISOString();
      }
    );
  },
});

/* Actions */
export const { resetTestData } = testDataSlice.actions;

/* Reducer */
export default testDataSlice.reducer;
